import { render } from "./SideBarSubItemComp.vue?vue&type=template&id=3dda7398"
import script from "./SideBarSubItemComp.vue?vue&type=script&lang=js"
export * from "./SideBarSubItemComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__